import React from "react";
import { Link } from "react-router";

const CheckoutCancel = () => {
    return (
        <div>
            <div>Update subscription cancelled</div>
            <div style={{ marginTop: "30px" }}>
                <Link to="/" style={{ marginRight: "20px" }}>
                    Back to Home
                </Link>
            </div>
        </div>
    );
};

export default CheckoutCancel;
